'use client';
import 'client-only';

import { ToolsConfigurationFeature } from '../common/features/tools-configuration-feature';
import { createUseFlag } from './create-use-flag';

export const useToolsConfigurationFeature = createUseFlag(
  ToolsConfigurationFeature
);
